import React from "react";
import Loader from 'react-loader-spinner'
import FilterModal from "../../modals/FilterModal";
import { getBoundingClientRect } from "../../utils/functions";
import HttpService from '../../utils/Http.services';
import { checkTextTranslation, checkTranslation, getObject, imageAddress, paramToStandardOption, translate } from "../../utils/useful";
import FixedView from "../FixedView";
import StagesManager from "../StagesManager";
import ParamsListItems from "./ParamsListItems";


class VariablesInput extends React.Component {

    state = {
        isOpen: false,
        data: [],
        title: '',
        tempData: [],
        options: [],
        isLoading: false,
        choosen: [],
        editMode: false,
        // lastNewId: 0,
        search: ''

    }


    componentDidMount() {
        this.mounted = true
        // console.log(this.props.data)
        this.init()

    }

    componentDidUpdate(prevProps) {

        if (prevProps.data != this.props.data && this.mounted) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }


    init() {



        if (this.props.data && typeof this.props.data == 'string') {

            let choosen = this.valueToOption(this.props.data)

            this.setState({ choosen })
            // if (this.props.header.information?.type == "local") {

            //     let options = []
            //     let choosen = []

            //     if (this.props.header.information?.items && this.props.header.information?.items.length > 0) {
            //         options = this.props.header.information?.items
            //     }

            //     if (this.props.title && Array.isArray(this.props.title)) {
            //         this.props.title.forEach(element => {
            //             choosen.push({ title: element, value: element })
            //         });
            //     }
            //     // console.log(this.props.title)
            //     this.setState({ options, choosen })
            // } else if ( this.props.header.information?.type == "api") {
            //     // console.log(this.props.title)
            // this.fetch()
            // }
        }
    }



    toggleOpen = (open) => {
        // console.log("HERE")
        let disabled = this.props.header?.information?.disabled
        if (!disabled) {
            let openState = open != null ? open : !this.state.isOpen

            if (openState) {
                this.fixedView.showView()
            } else {
                this.fixedView.hideView()
            }

            this.setState({ isOpen: openState, data: this.props.data })
        }

    }



    // closeBox = (event) => {
    //     if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isOpen) {
    //         this.setState({ isOpen: false, data: this.props.data })
    //         document.removeEventListener('mousedown', this.closeBox);
    //         window.removeEventListener('scroll', this.getPosition);

    //         // this.refs.icon.classList.toggle("rotate-180")

    //     }
    // }


    // getPosition = () => {
    //     // console.log("getPosition")
    //     let rect = getBoundingClientRect(this.wrapperRef)
    //     let indicatorBound = getBoundingClientRect(this.positionIndicator)


    //     let windowTop = indicatorBound.top > 0 ? indicatorBound.top : 0

    //     let spaceFromBottom = window.innerHeight - rect.top - windowTop - 35
    //     let spaceFromTop = rect.top + windowTop



    //     let top = rect.top - indicatorBound.top
    //     let left = rect.left - indicatorBound.left
    //     let maxHeight = 300

    //     if (spaceFromBottom < maxHeight) {
    //         if (spaceFromBottom < spaceFromTop) {

    //             // if (spaceFromTop - 10 > maxHeight) {
    //             maxHeight = spaceFromTop > maxHeight ? maxHeight : (spaceFromTop - 10)
    //             // }
    //             top = top - maxHeight - 8
    //         } else {
    //             top = top + 35
    //             maxHeight = spaceFromBottom - 10
    //         }
    //     } else {
    //         top = top + 35
    //     }
    //     this.setState({ top: top, left: left - 10, maxHeight }, () => {
    //         // let listBound = getBoundingClientRect(this.listView)

    //         // console.log(window.innerHeight - top-35)
    //         // console.log(listBound.height)
    //         // console.log((window.innerHeight - top - 35) < listBound.height)

    //         // if (window.innerHeight - top - 35 < listBound.height) {

    //         //     let maxHeight = 300

    //         //     if(top - listBound.height-7 > listBound.height){
    //         //          top = top - listBound.height

    //         //          console.log("TP1")
    //         //     }else{

    //         //         console.log("TP2")
    //         //         console.log((top + indicatorBound.top - 7))
    //         //         console.log((window.innerHeight - indicatorBound.top - top - 35))

    //         //         if((top + indicatorBound.top - 7) > (window.innerHeight - indicatorBound.top - top - 35)){

    //         //             console.log("TP3")
    //         //             top = top - listBound.height
    //         //             maxHeight = top - indicatorBound.top - 7

    //         //         }else{
    //         //             maxHeight = window.innerHeight - top - indicatorBound.top - 35
    //         //             console.log("TP4")
    //         //             top = top+35
    //         //         }

    //         //     }

    //         //     console.log("maxHeight")
    //         //     console.log(maxHeight)
    //         //     console.log(top)
    //         //     console.log(listBound.height)

    //         //     this.setState({top:top,maxHeight})
    //         //     // console.log(window.innerHeight - top)
    //         // }

    //     })
    // }



    // changeItem = (prop, selected, dontChangeValue) => {
    //     // console.log("changeItem")
    //     // console.log(prop)
    //     // var choosen = this.state.choosen
    //     this.setState({ title: '', search: '', choosen: prop }, () => {
    //         this.changeValue()
    //         if (this.state.tempData.length > 0)
    //             this.setState({ options: this.state.tempData })

    //         // if (this.refs.input)
    //         //     this.refs.input.focus()
    //     })


    //     // if (selected) {
    //     //     for (let i = 0; i < choosen.length; i++) {

    //     //         if (choosen[i].value == prop.value) {
    //     //             choosen.splice(i, 1)
    //     //         }
    //     //     }
    //     // } else {
    //     //     choosen.push(prop)
    //     // }

    //     // this.setState({ choosen }, () => {
    //     //     if (!dontChangeValue) 
    //     // })

    //     setTimeout(() => {
    //         this.toggleOpen(false)
    //     }, 1);

    //     // setTimeout(
    //     //     function () {
    //     //         this.toggleOpen()
    //     //     }
    //     //         .bind(this),
    //     //     1
    //     // );




    //     // this.changeFilter(prop.value)

    // }

    // setWrapperRef(node) {
    //     this.wrapperRef = node;
    // }



    // fetch() {
    //     this.setState({ isLoading: true })
    //     let address = this.props.header.information?.address ?? "searchUser"
    //     let filter = this.props.header.information?.filter ? (typeof this.props.header.information?.filter == "string" ? JSON.parse(this.props.header.information?.filter) : this.props.header.information?.filter) : {}
    //     // console.log(filter)
    //     // console.log(filter)
    //     // console.log(address)

    //     for (const [key, value] of Object.entries(filter)) {
    //         if (/\{\{(.*?)\}\}/.test(value)) {

    //             if (this.props.variables) {
    //                 filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
    //             }
    //             // console.log("VAR")
    //         }
    //     }
    //     // console.log(this.props.variables)
    //     // console.log(filter)

    //     let fields = (this.props.header.information?.fields && Object.keys(this.props.header.information?.fields)?.length) ? this.props.header.information?.fields : { title: 'fullname', description: 'username', value: '_id', image: 'image' }



    //     HttpService.request(address, filter, (fetchResult, fetchError) => {

    //         // console.log(fetchError)

    //         if (fetchError) { return }

    //         // console.log(fetchResult)
    //         // fetch(address, {
    //         //     method: 'POST',
    //         //     body: JSON.stringify(filter),
    //         //     headers: headers
    //         // }).then(response => response.json()).then(data => {
    //         // console.log(data)
    //         // if (data.status == 200 && this.mounted) {
    //         let newData = []
    //         let newParents = []

    //         fetchResult.info.sort((a, b) => { return a.values?.parent - b.values?.parent })


    //         fetchResult.info.forEach(element => {

    //             let newTitle = getObject(element, fields.title)
    //             let newValue = getObject(element, fields.value)
    //             let newImage
    //             let newDescription
    //             if (fields.image) {
    //                 newImage = getObject(element, fields.image)
    //             }
    //             if (fields.description) {
    //                 newDescription = getObject(element, fields.description)
    //             }
    //             let parent = getObject(element, fields?.parent)

    //             // if (parent && parent != '') {
    //             if (newValue) {
    //                 newData.push({ value: newValue, title: newTitle, image: newImage, description: newDescription, parent: ((parent && typeof parent == 'object') ? parent._id : parent) })
    //             }
    //             // } else {
    //             //     newParents.push({ value: newValue, title: newTitle,image:newImage, parent: (typeof parent == 'object' ? parent._id : parent) })
    //             // }

    //         });


    //         newParents.sort((a, b) => { return a.values?.name - b.values?.name })

    //         // console.log('/////////')
    //         // console.log(this.props.data)
    //         let userId
    //         if (this.props.data) {
    //             userId = typeof this.props.data == 'object' ? this.props.data._id : this.props.data
    //         }

    //         let choosen
    //         if (userId) {
    //             newData.forEach(oneNewData => {
    //                 // console.log(oneNewData.value)
    //                 if (oneNewData.value == userId) {
    //                     // console.log("OK!!!")
    //                     choosen = oneNewData
    //                     // this.setState({ choosen: oneNewData })
    //                     // choosen.push({ title: oneNewData.title, value: oneTitleId })
    //                 }
    //             });
    //         }

    //         if (!choosen) {
    //             choosen = this.valueToOption(userId)
    //         }

    //         // console.log(newData)

    //         // if (Array.isArray(this.props.data)) {
    //         //     let choosen = []
    //         //     this.props.data.forEach(oneTitle => {
    //         //         let oneTitleId = typeof oneTitle == 'object' ? oneTitle._id : oneTitle
    //         //         newData.forEach(oneNewData => {

    //         //             if (oneNewData.value == oneTitleId) {
    //         //                 choosen.push({ title: oneNewData.title, value: oneTitleId })
    //         //             }
    //         //         });

    //         //     })
    //         //     this.setState({ choosen })
    //         //     // console.log(choosen)


    //         // }

    //         this.setState({
    //             choosen,
    //             options: newData,
    //             parents: newParents,
    //             isLoading: false
    //         })
    //     })

    //     // }).catch(error => this.setState({ error, isLoading: false }));
    // }


    // spliter(source, string) {
    //     if (string) {
    //         var stringArray = string.split('.')
    //         var finalString = source
    //         stringArray.forEach(element => {
    //             finalString = finalString[element]
    //         });
    //     }
    //     return finalString
    // }




    // search = async (value) => {
    //     // console.log("SEARCH")

    //     // console.log(this.state.options)
    //     this.setState({ title: value })
    //     this.setState({ search: value })

    //     if (!this.state.isOpen) {
    //         this.toggleOpen()
    //     }

    //     if (value == "") {
    //         await this.setState({ options: this.state.tempData }, async () => {
    //             await this.setState({ tempData: [] })
    //         })
    //     } else {
    //         if (this.state.tempData.length == 0) {
    //             // console.log("HERE")
    //             await this.setState({ tempData: this.state.options }, () => {
    //                 // console.log(this.state.tempData)
    //             })
    //         }
    //         var values = []
    //         // var values = this.props.data.filter((e) => e.title === value)
    //         // console.log(this.state.tempData)
    //         this.state.tempData.forEach(element => {
    //             // console.log(element)

    //             if (String(element.title).toLowerCase().includes(String(value).toLowerCase())) {
    //                 values.push(element)
    //             }
    //         })
    //         // console.log(values)

    //         this.setState({ options: values })

    //         // }
    //     }
    // }


    // removeItem(index) {
    //     // let choosen = [...this.state.choosen]
    //     // choosen.splice(index, 1)
    //     this.setState({ choosen: '' }, () => {
    //         this.changeValue()
    //     })
    // }



    changeValue() {
        // let choosen = []
        // this.state.choosen.forEach(element => {
        //     choosen.push((typeof element.value == 'object' ? element.value._id : element.value))
        //     // choosen.push((element.value))

        // });
        // console.log(choosen)
        // console.log(this.state.choosen)
        this.props.changeValue(this.props.header.key, (typeof this.state.choosen == 'object' ? this.state.choosen.value : this.state.choosen), this.props.extra, this.state.choosen)
    }

    // openFilter = () => {
    //     this.filterModal.modal.showModal()
    // }

    // changeName = (key, value) => {
    //     this.props.changeValue('fullname', value, this.props.extra)
    // }

    showVariables = () => {

        this.stagesManager.changeStage('variables')
        setTimeout(() => {
            this.fixedView.getBounding()
        }, 100);
    }

    goToMain = () => {
        this.stagesManager.changeStage('main')
        setTimeout(() => {
            this.fixedView.getBounding()
        }, 100);
    }

    useVariableValue = (key, value, extra) => {

        if (this.fixedView) {
            this.fixedView.hideView()
        }
        // let finalValue = paramToStandardOption(this.props.params, value)

        let choosen = this.valueToOption(value)

        this.setState({ choosen }, () => {

            this.changeValue()

        })
    }

    valueToOption = (value) => {

        let [finalValue] = paramToStandardOption(this.props.params, value, "{{")

        // console.log(value,finalValue)

        let choosen = {

            title: finalValue ? ((finalValue.label ?? finalValue.title) ?? (finalValue.name ?? finalValue?.information?.label)) : '{{lang}}Invalid!',
            value: value,
            type: 'variable'
            // description: "{{lang}}Variable"
        }

        return choosen
    }



    render() {

        let info = this.props.header?.information

        return (
            <div className='mt-0 w-100 h-100 flexc ' style={{ position: 'relative' }}  >

                <div className="w-100" >

                    <div className="flexcb w-100 h-100">
                        <div className="ref" ref={el => this.currentNode = el} onClick={() => { if (!this.props.data || typeof this.props.data != 'object') { this.toggleOpen(true) } }} style={{ minWidth: 0, flex: 1, cursor: 'pointer' }}>
                            {this.props.header.information?.placeholder && (!this.props.data || this.props.data == '') && (
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mrd-1 mld-1 placeholder py-2'}>{checkTextTranslation(this.props.header.information?.placeholder)}</label>
                                </div>
                            )}
                            {!this.props.header.information?.placeholder && (!this.props.data || this.props.data == '') &&
                                <div className="h-100 flexc" style={{ flex: 1 }}>
                                    <label className={' mrd-1 mld-1 placeholder py-2'}>{checkTextTranslation('Select User...')}</label>
                                </div>
                            }

                            {(this.props.data && this.props.data != '') && (
                                <div className="w-100 h-100 flexc mrd-2 ">

                                    <div className="flexcc br-20 " style={{ padding: 6 }}>
                                        <img src={'/assets/icons/useful/brackets-curly.svg'} width="14px" style={{ height: 14, objectFit: 'cover' }} alt="" />
                                    </div>



                                    <div className="flex-1" style={{ minWidth: 0 }}>
                                        <p className="text-small w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', }}>{checkTranslation(this.state.choosen?.title)}</p>

                                        {/* {(!this.props.isConditionComponent && this.state.choosen?.type != 'variable') && (
                                            <>
                                                {this.state.choosen?.description ? (
                                                    <p className="text-smaller" style={{ textOverflow: 'ellipsis', overflow: 'hidden', color: '#777', fontWeight: 400 }}>@{this.state.choosen?.description}</p>
                                                ) : (
                                                    <p className={"text-smaller " + (this.state.editMode ? ' mx-2 mt-1 ' : '')} style={{ textOverflow: 'ellipsis', overflow: 'hidden', color: '#777', fontWeight: 400 }}>{translate("Virtual hub")}</p>
                                                )}
                                            </>
                                        )} */}
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>


                    {this.state.isLoading && (
                        <div style={{ position: 'absolute', top: 3, right: 5 }}>
                            <Loader
                                type="Oval"
                                color="#FF6C00"
                                height="20"
                                width="20"
                            />
                        </div>
                    )}



                    <FixedView ref={el => this.fixedView = el} nodeRef={this.currentNode} onHide={this.onHide} topOffset={4} bottomOffset={10} zIndex={5} xOffset={0} rightAlign={false}>

                        <div style={{ display: 'flex', zIndex: 5, maxWidth: 300, maxHeight: 250, minWidth: 250 }} >

                            <div className={'h-100'} style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#ffffff', borderRadius: 8, maxHeight: this.state.maxHeight, overflow: 'auto', boxShadow: '0px 0px 30px rgba(0,0,0,0.1)', border: '1px solid #eee' }}>

                                <div className="scroll-no-scrollbar h-100" style={{ maxHeight: '200px' }}>

                                    <ParamsListItems data={this.props.data} params={this.props.params} validTypes={this.props.header?.information?.validTypes} goToMain={this.goToMain} changeValue={this.useVariableValue} variableIndicatior={"{{"} />

                                </div>

                            </div>
                        </div>

                    </FixedView>

                </div>


            </div>
        );
    }
}


export default VariablesInput;
